<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
            <p class="buttons" v-if="isEditable">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                   @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
            </p>
            <h1 v-if="entity.name">{{ entity.name }}</h1>
        </div>

        <div class="responsiveTabs">

            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileDetailProperties'}"><a @click.stop="openRoute('deviceProfileDetailProperties')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileDetailProtocols'}"><a @click.stop="openRoute('deviceProfileDetailProtocols')" v-translate>Nastavení protokolů</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileDetailLinearProtocols'}"><a @click.stop="openRoute('deviceProfileDetailLinearProtocols')" v-translate>Protokoly pro lineární obsah</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceProfileDetailNonLinearProtocols'}"><a @click.stop="openRoute('deviceProfileDetailNonLinearProtocols')" v-translate>Protokoly pro nelineární obsah</a></li>
            </ul>

            <router-view
                :isEditable="isEditable"
                :entity="entity"
                :codecs="codecs"
                :protocols="protocols"
                :deviceTypes="deviceTypes"
                :streamProfiles="streamProfiles"
                :operatorOptions="operatorOptions"
                :operatorIdComputed="operatorIdComputed"
                @addProtocol="onAddProtocol"
            />

            <section class="buttons" v-if="isEditable">
                <p>
                    <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam profilů zařízení</router-link>
                    <input v-if="$_updateActionAllowed"
                           type="submit"
                           :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="submitForm()">
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import deviceProfiles from "@/components/views/deviceProfiles/mixins/deviceProfiles"

export default {
    name: "DeviceProfileDetail",
    mixins: [detailActions, deviceProfiles],
    data() {
        return {
            codecs: [],
            protocols: [],
            deviceTypes: [],
            streamProfiles: []
        }
    },
    created(DeviceProfileService, OperatorService) {
        this.entityService = DeviceProfileService;

        if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
            this.getOperators().then(() =>{
              this.operators = [{'id': null, 'name': this.$gettext('Nenastaven')}, ...this.operators];
            });
        }

        this.getDependency().then(() => {
            this.createdInit();
        });
    },
    computed: {
        isEditable() {
            return this.$_updateActionAllowed;
        },
    },
    methods: {
        getEntity() {
            this.setLoadingMessage()

            return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(data => {
                    this.entity = data.device_profile
                    this.emptyMessage()
                })
                .then(() => {
                    this.$refs['deviceprofilebasicform'].validateFormRequiredFields()
                })
                .catch(function (error) {
                    this.setErrorMessage(error['error_message'])
                }.bind(this))
        },
        updateEntity(params, redirect = false) {
            this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
                .then(() => {
                    if (redirect === true) {
                        this.redirect(this.moduleName)
                    } else {
                        this.emptyMessage()
                        this.getEntity().then(() => {
                          this.setSuccessMessage()
                        })
                    }
                })
                .catch(function (error) {
                    this.setErrorMessage(this.processErrorMessage(error))
                }.bind(this))
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/DeviceProfileDetail.vue